import {
  Box,
  Button,
  Typography,
} from '@mui/material';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';

import { Helmet } from 'react-helmet-async';

import FormStyle from '../FormStyle';

function SentEmailWithSuccess(
  {
    setIsChangingEmail,
    setHasSentMail,
  }: {
    setIsChangingEmail: (isChangingEmail: boolean) => void,
    setHasSentMail: (hasSentMail: boolean) => void,
  },
) {
  const handleReturn = () => {
    setIsChangingEmail(false);
    setHasSentMail(false);
  };

  return (
    <>
      <Helmet>
        <title>メールアドレス変更</title>
      </Helmet>
      <Box className="container-fluid my-2">
        <Box
          sx={FormStyle.previewHeader}
        >
          <h1 className="text-bold my-3">
            メールアドレス変更
          </h1>

          <Box
            sx={{
              border: '2px solid #dc3545',
              padding: '0.5rem',
            }}
          >
            <Typography
              fontSize={12}
              color="#dc3545"
            >
              <FontAwesomeIcon icon={faCircleExclamation} className="mx-2" />
              <span>まだメールアドレスの変更は完了しておりません</span>
            </Typography>
          </Box>
        </Box>

        <Box className="card text-center">
          <Box className="card-body">
            <h3 className="text-bold">
              本人確認用メールを送信いたしました
            </h3>
            <br />
            <p className="text-start">
              ご入力いただいたメールアドレスに本人確認用のURLをメール送信しましたのでご確認ください。
            </p>
            <br />
            <p className="text-start">
              しばらく経ってもメールが届かない場合は、迷惑フォルダに入っているか、間違ったメールアドレスを入力されたか可能性があります。ご確認をお願いいたします。
            </p>
            <br />
            <Button
              onClick={handleReturn}
              variant="outlined"
              className="btn-outline-secondary"
            >
              戻る
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default SentEmailWithSuccess;
